"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToggleSwitchGroup = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lodash = require("lodash");
var _ToggleButton = require("../../ToggleButton");
require("./style.css");
class ToggleSwitchGroup extends _react.default.PureComponent {
  toggleField = [];
  childList = [];
  state = {
    isParent: false
  };
  componentDidMount() {
    const {
      defaultOnList,
      child,
      setValue,
      name
    } = this.props;
    if ((0, _lodash.isEqual)((0, _lodash.sortBy)(defaultOnList), (0, _lodash.sortBy)(child))) {
      this.getTogglelabel('', true, true);
    } else {
      this.getTogglelabel('', false, false);
    }
    if (defaultOnList && defaultOnList.length) {
      this.toggleField.forEach(item => {
        /* istanbul ignore else */
        if (defaultOnList.includes(item.props.label)) {
          item.state.value = true;
        }
      });
      this.childList = [...defaultOnList];
      /* istanbul ignore else */
      if (setValue) setValue(name, this.childList);
    }
  }
  getTogglelabel = (val, state, parent) => {
    const {
      setValue,
      name,
      child,
      getToggleState
    } = this.props;
    if (getToggleState) {
      getToggleState(val, state, parent);
    }

    // When parent switch is enabled
    if (parent) {
      this.setState({
        isParent: state
      });

      /* istanbul ignore else */
      if (state) {
        this.childList = [...child];
      } else {
        this.childList = [];
      }
    }

    // When only child switch(s)  enabled
    if (!parent) {
      /* istanbul ignore else */
      if (state) {
        this.childList.push(val);
      } else {
        this.childList = this.childList.filter(item => item !== val);
      }
    }
    /* istanbul ignore else */
    if (setValue) setValue(name, this.childList);
  };
  render() {
    const {
      parent,
      child
    } = this.props;
    const {
      isParent
    } = this.state;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "toggle__group"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "toggle__group--parent"
    }, /*#__PURE__*/_react.default.createElement(_ToggleButton.ToggleButton, (0, _extends2.default)({}, this.props, {
      value: isParent,
      key: parent,
      label: parent,
      getTogglelabel: this.getTogglelabel,
      parent: true
    }))), /*#__PURE__*/_react.default.createElement("div", {
      className: `custom-scrollbar ${!isParent ? 'toggle__group--show' : 'toggle__group--hide'}`
    }, child.map((childEle, index) => {
      return /*#__PURE__*/_react.default.createElement("div", {
        key: index,
        className: "toggle__group--child"
      }, /*#__PURE__*/_react.default.createElement(_ToggleButton.ToggleButton, {
        ref: elem => {
          return this.toggleField = [...this.toggleField, elem];
        },
        value: isParent,
        label: childEle,
        getTogglelabel: this.getTogglelabel
      }));
    })));
  }
}
exports.ToggleSwitchGroup = ToggleSwitchGroup;
ToggleSwitchGroup.propTypes = {
  name: _propTypes.default.string.isRequired,
  parent: _propTypes.default.string.isRequired,
  child: _propTypes.default.array.isRequired,
  setValue: _propTypes.default.func
};